export interface PasswPolicies {
    hasLength: boolean,
    hasCapitalLetter: boolean,
    hasLowercaseLetter: boolean,
    hasNumber: boolean,
    hasPunctuation: boolean,

    checkedCounter: number,
}

export class PasswPolicies {
    static minLength = 8;
    static numMinRoles = 5;
    static getInstance = (): PasswPolicies => {
        return {
            hasLength: false,
            hasCapitalLetter: false,
            hasLowercaseLetter: false,
            hasNumber: false,
            hasPunctuation: false,
            checkedCounter: 0,
        }
    }

    static validate = (password: string) => {
        const check = PasswPolicies.getInstance();

        if (password) {
            if (password.length >= PasswPolicies.minLength) {
                check.hasLength = true;
                ++check.checkedCounter;
            }
            const charPassw = Array.from(password);
            for (let ind0 = 0; ind0 < charPassw.length; ++ind0) {
                if (!check.hasCapitalLetter && charPassw[ind0] >= 'A' && charPassw[ind0] <= 'Z') {
                    check.hasCapitalLetter = true;
                    ++check.checkedCounter;
                }
                if (!check.hasLowercaseLetter && charPassw[ind0] >= 'a' && charPassw[ind0] <= 'z') {
                    check.hasLowercaseLetter = true;
                    ++check.checkedCounter;
                }
                if (!check.hasNumber && charPassw[ind0] >= '0' && charPassw[ind0] <= '9') {
                    check.hasNumber = true;
                    ++check.checkedCounter;
                }
                var charCode = charPassw[ind0].charCodeAt(0);
                if (!check.hasPunctuation && ((charCode >= 33 && charCode <= 47) || (charCode >= 58 && charCode <= 64) || charCode === 247 || charCode === 242)) {
                    check.hasPunctuation = true;
                    ++check.checkedCounter;
                }
            }
        }
        return check;
    }
}

/*
const validatePassw = (v: string) => {
    return PasswPolicies.validate(v).checkedCounter === PasswPolicies.numMinRoles;
}

//https://stackoverflow.com/questions/70480928/how-to-validate-password-and-confirm-password-in-react-hook-form-is-there-any-v
export const passwordRules = {
    validate: {
        required: (v: string) => (v ? true : false) || 'Campo obbligatorio.',
        validatePassPolicies: (v: string) => validatePassw(v) || 'La password deve essere conforme ai requisiti di complessità',
    }
}
export const ripetiPasswordRules = {
    validate: {
        required: (v: string) => (v ? true : false) || 'Campo obbligatorio.',
        match: (v: string) => {
            const password = getValues('password');
            return password === v || "Le password non coincidono!";
        }
    }
}
*/